/* RESPONSIBLE TEAM: team-omni */
import Service from '@ember/service';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type Session from 'embercom/services/session';

type DiscordIntegration = {
  id: string;
};

export default class DiscordIntegrationService extends Service {
  @service declare session: Session;

  @tracked existingIntegrationsIds: string[] | null = null;

  async loadIntegration(): Promise<void> {
    if (!this.session.workspace.isFeatureEnabled('discord-channel')) {
      return;
    }

    try {
      let response = await fetch(`/ember/discord/integrations?app_id=${this.session.workspace.id}`);

      if (response.ok) {
        let integrations = (await response.json()) as DiscordIntegration[];
        this.existingIntegrationsIds = integrations.map((integration) => integration.id);
        return;
      }

      console.error('Error loading Discord integration:', response.statusText);
    } catch (e: unknown) {
      console.error('Error loading Discord integration:', e);
    }

    this.existingIntegrationsIds = null;
  }

  get hasIntegrations(): boolean {
    return (this.existingIntegrationsIds?.length ?? 0) > 0;
  }
}

declare module '@ember/service' {
  interface Registry {
    'discord-integration-service': DiscordIntegrationService;
  }
}
